import { portalWalkthrough } from "../../constants/actionTypes";

const setPortalSteps = (data) => ({
  type: portalWalkthrough.SET_STEPS,
  payload: data,
});

const startPortalWalkthrough = () => ({ type: portalWalkthrough.START });

const resetPortalSteps = () => ({
  type: portalWalkthrough.RESET,
});

const stopPortalSteps = () => ({
  type: portalWalkthrough.STOP,
});

const setNextOrPrevStep = (data) => ({
  type: portalWalkthrough.NEXT_OR_PREV,
  payload: data,
});

const restartPortalSteps = () => ({
  type: portalWalkthrough.RESTART,
});


export { setPortalSteps, resetPortalSteps, stopPortalSteps, setNextOrPrevStep, restartPortalSteps, startPortalWalkthrough };
